/* eslint-disable no-console,no-undef, camelcase */
import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import BehaviorForm from "./BehaviorForm";
import { ChallengeTitle } from '../CreateChallenge/styles';
import Waiting from '../Waiting';
import { withTranslation } from 'react-i18next';

class BehaviorChallenge extends PureComponent {

  getChallenge = (props) => {
    const { createChallengeById, getBehvaiorChallengeByIdAction, match, editLibrary} = props;
    const { params } = match;
    if(createChallengeById || editLibrary) {
      getBehvaiorChallengeByIdAction(params.id);
    }
  };

  componentDidMount() {
    this.getChallenge(this.props);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.match.params.id !== this.props.match.params.id) {
      this.getChallenge(this.props);
    }
  }

  render() {
    const { role, createChallenge, createLibrary, createBehaviorLibrary, createChallengeById, 
      behaviorChallengeDetailsById, match, editLibrary, t} = this.props;
    const { params: { id } } = match;
    if(((createChallengeById || editLibrary) && !behaviorChallengeDetailsById) || (createChallengeById && 
      behaviorChallengeDetailsById && (behaviorChallengeDetailsById.id.toString() != id))) {
      return <Waiting />
    }
    return (
      <div>
        <ChallengeTitle padding="30px 30px 10px">{`${editLibrary ? t("Edit") : t("Create")} ${t("a Behavior")} ${createLibrary || editLibrary ? t('Library') : t('Challenge') }`}</ChallengeTitle>
        <BehaviorForm
          history={this.props.history}
          role={role}
          createChallenge={createChallenge}
          createBehaviorLibrary={createBehaviorLibrary}
          createLibrary={createLibrary}
          createChallengeById={createChallengeById}
          behaviorChallengeDetailsById={behaviorChallengeDetailsById}
          challengeId={(editLibrary || createChallengeById) && behaviorChallengeDetailsById.id}
          editLibrary={editLibrary}
        />
      </div>
    )
  }
}

BehaviorChallenge.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  createChallenge: PropTypes.func,
  createLibrary: PropTypes.bool,
  createBehaviorLibrary: PropTypes.func,
  createChallengeById: PropTypes.bool,
  getBehvaiorChallengeByIdAction: PropTypes.func,
  behaviorChallengeDetailsById: PropTypes.object,
  match: PropTypes.object.isRequired,
  editLibrary: PropTypes.bool,
  t: PropTypes.func
};

export default (withTranslation()(BehaviorChallenge));